module.exports = __webpack_public_path__ + "img/up.17c3b1bf.svg";